// 각 항목의 key 는 저장된 문서와 목록 항목을 연결하는 고유 식별자입니다.
// 이후 개정으로 문구(value)나 순서가 바뀌어도 key 는 절대 변경/재사용하지 마세요.
export default [
  {
    key: `regular`,
    value: `정기안전교육`,
    child: [
      {
        key: `regular-direct`,
        value: `-`,
        textarea: `■ 산업안전 및 산업재해 예방에 관한 사항\n  (화재·폭발 사고 발생 시 대피에 관한 사항을 포함한다)\n\n■ 산업보건 및 건강장해 예방에 관한 사항\n  (폭염·한파작업으로 인한 건강장해 발생 시 응급조치에 관한 사항을 포함한다)\n\n■ 위험성평가에 관한 사항\n\n■ 건강증진 및 질병 예방에 관한 사항\n\n■ 유해·위험 작업환경 관리에 관한 사항\n\n■ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항\n\n■ 직무스트레스 예방 및 관리에 관한 사항\n\n■ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항`,
      },
    ],
  },
  {
    key: `special`,
    value: `특별안전보건교육`,
    child: [
      { key: `special-direct`, value: `-`, textarea: `` },
      {
        key: `special-common`,
        value: `공통교육내용`,
        textarea: `■ 산업안전 및 산업재해 예방에 관한 사항\n  (화재·폭발 사고 발생 시 대피에 관한 사항을 포함한다)\n\n■ 산업보건 및 건강장해 예방에 관한 사항\n\n■ 위험성평가에 관한 사항\n\n■ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항\n\n■ 직무스트레스 예방 및 관리에 관한 사항\n\n■ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항\n\n■ 기계·기구의 위험성과 작업의 순서 및 동선에 관한 사항\n\n■ 작업 개시 전 점검에 관한 사항\n\n■ 정리정돈 및 청소에 관한 사항\n\n■ 사고 발생 시 긴급조치에 관한 사항\n\n■ 물질안전보건자료에 관한 사항`,
      },
      {
        key: `special-1`,
        value: `1. 고압실 내 작업(잠함공법이나 그 밖의 압기공법으로 대기압을 넘는 기압인 작업실 또는 수갱 내부에서 하는 작업만 해당한다)`,
        textarea: `■ 고기압 장해의 인체에 미치는 영향에 관한 사항\n■ 작업의 시간·작업 방법 및 절차에 관한 사항\n■ 압기공법에 관한 기초지식 및 보호구 착용에 관한 사항\n■ 이상 발생 시 응급조치에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-2`,
        value: `2. 아세틸렌 용접장치 또는 가스집합 용접장치를 사용하는 금속의 용접·용단 또는 가열작업(발생기·도관 등에 의하여 구성되는 용접장치만 해당한다)`,
        textarea: `■ 용접 흄, 분진 및 유해광선 등의 유해성에 관한 사항\n■ 가스용접기, 압력조정기, 호스 및 취관두(불꽃이 나오는 용접기의 앞부분) 등의 기기점검에 관한 사항\n■ 작업방법·순서 및 응급처치에 관한 사항\n■ 안전기 및 보호구 취급에 관한 사항\n■ 화재예방 및 초기대응에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-3`,
        value: `3. 밀폐된 장소(탱크 내 또는 환기가 극히 불량한 좁은 장소를 말한다)에서 하는 용접작업 또는 습한 장소에서 하는 전기용접 작업`,
        textarea: `■ 작업순서, 안전작업방법 및 수칙에 관한 사항\n■ 환기설비에 관한 사항\n■ 전격 방지 및 보호구 착용에 관한 사항\n■ 질식 시 응급조치에 관한 사항\n■ 작업환경 점검에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-4`,
        value: `4. 폭발성·물반응성·자기반응성·자기발열성 물질, 자연발화성 액체·고체 및 인화성 액체의 제조 또는 취급작업(시험연구를 위한 취급작업은 제외한다)`,
        textarea: `■ 폭발성·물반응성·자기반응성·자기발열성 물질, 자연발화성 액체·고체 및 인화성 액체의 성질이나 상태에 관한 사항\n■ 폭발 한계점, 발화점 및 인화점 등에 관한 사항\n■ 취급방법 및 안전수칙에 관한 사항\n■ 이상 발견 시의 응급처치 및 대피 요령에 관한 사항\n■ 화기·정전기·충격 및 자연발화 등의 위험방지에 관한 사항\n■ 작업순서, 취급주의사항 및 방호거리에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-5`,
        value: `5. 액화석유가스·수소가스 등 인화성 가스 또는 폭발성 물질 중 가스의 발생장치 취급작업`,
        textarea: `■ 취급가스의 상태 및 성질에 관한 사항\n■ 발생장치 등의 위험 방지에 관한 사항\n■ 고압가스 저장설비 및 안전취급방법에 관한 사항\n■ 설비 및 기구의 점검 요령\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-6`,
        value: `6. 화학설비 중 반응기, 교반기·추출기의 사용 및 세척작업`,
        textarea: `■ 각 계측장치의 취급 및 주의에 관한 사항\n■ 투시창·수위 및 유량계 등의 점검 및 밸브의 조작주의에 관한 사항\n■ 세척액의 유해성 및 인체에 미치는 영향에 관한 사항\n■ 작업 절차에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-7`,
        value: `7. 화학설비의 탱크 내 작업`,
        textarea: `■ 차단장치·정지장치 및 밸브 개폐장치의 점검에 관한 사항\n■ 탱크 내의 산소농도 측정 및 작업환경에 관한 사항\n■ 안전보호구 및 이상 발생 시 응급조치에 관한 사항\n■ 작업절차·방법 및 유해·위험에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-8`,
        value: `8. 분말·원재료 등을 담은 호퍼(하부가 깔대기 모양으로 된 저장통)·저장창고 등 저장탱크의 내부작업`,
        textarea: `■ 분말·원재료의 인체에 미치는 영향에 관한 사항\n■ 저장탱크 내부작업 및 복장보호구 착용에 관한 사항\n■ 작업의 지정·방법·순서 및 작업환경 점검에 관한 사항\n■ 팬·풍기(風旗) 조작 및 취급에 관한 사항\n■ 분진 폭발에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-9`,
        value: `9. 다음 각 목에 정하는 설비에 의한 물건의 가열·건조작업\n가. 건조설비 중 위험물 등에 관계되는 설비로 속부피가 1세제곱미터 이상인 것\n나. 건조설비 중 가목의 위험물 등 외의 물질에 관계되는 설비로서, 연료를 열원으로 사용하는 것(그 최대 연소소비량이 매 시간당 10킬로그램 이상인 것만 해당한다) 또는 전력을 열원으로 사용하는 것(정격소비전력이 10킬로와트 이상인 경우만 해당한다)`,
        textarea: `■ 건조설비 내외면 및 기기기능의 점검에 관한 사항\n■ 복장보호구 착용에 관한 사항\n■ 건조 시 유해가스 및 고열 등이 인체에 미치는 영향에 관한 사항\n■ 건조설비에 의한 화재·폭발 예방에 관한 사항`,
      },
      {
        key: `special-10`,
        value: `10. 다음 각 목에 해당하는 집재장치(집재기·가선·운반기구·지주 및 이들에 부속하는 물건으로 구성되고, 동력을 사용하여 원목 또는 장작과 숯을 담아 올리거나 공중에서 운반하는 설비를 말한다)의 조립, 해체, 변경 또는 수리작업 및 이들 설비에 의한 집재 또는 운반 작업\n가. 원동기의 정격출력이 7.5킬로와트를 넘는 것\n나. 지간의 경사거리 합계가 350미터 이상인 것\n다. 최대사용하중이 200킬로그램 이상인 것`,
        textarea: `■ 기계의 브레이크 비상정지장치 및 운반경로, 각종 기능 점검에 관한 사항\n■ 작업 시작 전 준비사항 및 작업방법에 관한 사항\n■ 취급물의 유해·위험에 관한 사항\n■ 구조상의 이상 시 응급처치에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-11`,
        value: `11. 동력에 의하여 작동되는 프레스기계를 5대 이상 보유한 사업장에서 해당 기계로 하는 작업`,
        textarea: `■ 프레스의 특성과 위험성에 관한 사항\n■ 방호장치 종류와 취급에 관한 사항\n■ 안전작업방법에 관한 사항\n■ 프레스 안전기준에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-12`,
        value: `12. 목재가공용 기계[둥근톱기계, 띠톱기계, 대패기계, 모떼기 기계 및 라우터기(목재를 자르거나 홈을 파는 기계)만 해당하며, 휴대용은 제외한다]를 5대 이상 보유한 사업장에서 해당 기계로 하는 작업`,
        textarea: `■ 목재가공용 기계의 특성과 위험성에 관한 사항\n■ 방호장치의 종류와 구조 및 취급에 관한 사항\n■ 안전기준에 관한 사항\n■ 안전작업방법 및 목재 취급에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-13`,
        value: `13. 운반용 등 하역기계를 5대 이상 보유한 사업장에서의 해당 기계로 하는 작업`,
        textarea: `■ 운반하역기계 및 부속설비의 점검에 관한 사항\n■ 작업순서와 방법에 관한 사항\n■ 안전운전방법에 관한 사항\n■ 화물의 취급 및 작업신호에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-14`,
        value: `14. 1톤 이상의 크레인을 사용하는 작업 또는 1톤 미만의 크레인 또는 호이스트를 5대 이상 보유한 사업장에서 해당 기계로 하는 작업(제39호의 작업은 제외한다)`,
        textarea: `■ 방호장치의 종류, 기능 및 취급에 관한 사항\n■ 걸고리·와이어로프 및 비상정지장치 등의 기계·기구 점검에 관한 사항\n■ 화물의 취급 및 안전작업방법에 관한 사항\n■ 신호방법 및 공동작업에 관한 사항\n■ 인양 물건의 위험성 및 낙하·비래(飛來)·충돌재해 예방에 관한 사항\n■ 인양물이 적재될 지반의 조건, 인양하중, 풍압 등이 인양물과 타워크레인에 미치는 영향\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-15`,
        value: `15. 건설용 리프트·곤돌라를 이용한 작업`,
        textarea: `■ 방호장치의 기능 및 사용에 관한 사항\n■ 기계, 기구, 달기체인 및 와이어 등의 점검에 관한 사항\n■ 화물의 권상·권하 작업방법 및 안전작업 지도에 관한 사항\n■ 기계·기구에 특성 및 동작원리에 관한 사항\n■ 신호방법 및 공동작업에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-16`,
        value: `16. 주물 및 단조(금속을 두들기거나 눌러서 형체를 만드는 일) 작업`,
        textarea: `■ 고열물의 재료 및 작업환경에 관한 사항\n■ 출탕·주조 및 고열물의 취급과 안전작업방법에 관한 사항\n■ 고열작업의 유해·위험 및 보호구 착용에 관한 사항\n■ 안전기준 및 중량물 취급에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-17`,
        value: `17. 전압이 75볼트 이상인 정전 및 활선작업`,
        textarea: `■ 전기의 위험성 및 전격 방지에 관한 사항\n■ 해당 설비의 보수 및 점검에 관한 사항\n■ 정전작업·활선작업 시의 안전작업방법 및 순서에 관한 사항\n■ 절연용 보호구, 절연용 방호구 및 활선작업용 기구 등의 사용에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-18`,
        value: `18. 콘크리트 파쇄기를 사용하여 하는 파쇄작업(2미터 이상인 구축물의 파쇄작업만 해당한다)`,
        textarea: `■ 콘크리트 해체 요령과 방호거리에 관한 사항\n■ 작업안전조치 및 안전기준에 관한 사항\n■ 파쇄기의 조작 및 공통작업 신호에 관한 사항\n■ 보호구 및 방호장비 등에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-19`,
        value: `19. 굴착면의 높이가 2미터 이상이 되는 지반 굴착(터널 및 수직갱 외의 갱 굴착은 제외한다)작업`,
        textarea: `■ 지반의 형태·구조 및 굴착 요령에 관한 사항\n■ 지반의 붕괴재해 예방에 관한 사항\n■ 붕괴 방지용 구조물 설치 및 작업방법에 관한 사항\n■ 보호구의 종류 및 사용에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-20`,
        value: `20. 흙막이 지보공의 보강 또는 동바리를 설치하거나 해체하는 작업`,
        textarea: `■ 작업안전 점검 요령과 방법에 관한 사항\n■ 동바리의 운반·취급 및 설치 시 안전작업에 관한 사항\n■ 해체작업 순서와 안전기준에 관한 사항\n■ 보호구 취급 및 사용에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-21`,
        value: `21. 터널 안에서의 굴착작업(굴착용 기계를 사용하여 하는 굴착작업 중 근로자가 칼날 밑에 접근하지 않고 하는 작업은 제외한다) 또는 같은 작업에서의 터널 거푸집 지보공의 조립 또는 콘크리트 작업`,
        textarea: `■ 작업환경의 점검 요령과 방법에 관한 사항\n■ 붕괴 방지용 구조물 설치 및 안전작업 방법에 관한 사항\n■ 재료의 운반 및 취급·설치의 안전기준에 관한 사항\n■ 보호구의 종류 및 사용에 관한 사항\n■ 소화설비의 설치장소 및 사용방법에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-22`,
        value: `22. 굴착면의 높이가 2미터 이상이 되는 암석의 굴착작업`,
        textarea: `■ 폭발물 취급 요령과 대피 요령에 관한 사항\n■ 안전거리 및 안전기준에 관한 사항\n■ 방호물의 설치 및 기준에 관한 사항\n■ 보호구 및 신호방법 등에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-23`,
        value: `23. 높이가 2미터 이상인 물건을 쌓거나 무너뜨리는 작업(하역기계로만 하는 작업은 제외한다)`,
        textarea: `■ 원부재료의 취급 방법 및 요령에 관한 사항\n■ 물건의 위험성·낙하 및 붕괴재해 예방에 관한 사항\n■ 적재방법 및 전도 방지에 관한 사항\n■ 보호구 착용에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-24`,
        value: `24. 선박에 짐을 쌓거나 부리거나 이동시키는 작업`,
        textarea: `■ 하역 기계·기구의 운전방법에 관한 사항\n■ 운반·이송경로의 안전작업방법 및 기준에 관한 사항\n■ 중량물 취급 요령과 신호 요령에 관한 사항\n■ 작업안전 점검과 보호구 취급에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-25`,
        value: `25. 거푸집 동바리의 조립 또는 해체작업`,
        textarea: `■ 동바리의 조립방법 및 작업 절차에 관한 사항\n■ 조립재료의 취급방법 및 설치기준에 관한 사항\n■ 조립ㆍ해체 시의 사고 예방에 관한 사항\n■ 보호구 착용 및 점검에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-26`,
        value: `26. 비계의 조립·해체 또는 변경작업`,
        textarea: `■ 비계의 조립순서 및 방법에 관한 사항\n■ 비계작업의 재료 취급 및 설치에 관한 사항\n■ 추락재해 방지에 관한 사항\n■ 보호구 착용에 관한 사항\n■ 비계상부 작업 시 최대 적재하중에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-27`,
        value: `27. 건축물의 골조, 다리의 상부구조 또는 탑의 금속제의 부재로 구성되는 것(5미터 이상인 것만 해당한다)의 조립·해체 또는 변경작업`,
        textarea: `■ 건립 및 버팀대의 설치순서에 관한 사항\n■ 조립ㆍ해체 시의 추락재해 및 위험요인에 관한 사항\n■ 건립용 기계의 조작 및 작업신호 방법에 관한 사항\n■ 안전장비 착용 및 해체순서에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-28`,
        value: `28. 처마 높이가 5미터 이상인 목조건축물의 구조 부재의 조립이나 건축물의 지붕 또는 외벽 밑에서의 설치작업`,
        textarea: `■ 붕괴·추락 및 재해 방지에 관한 사항\n■ 부재의 강도·재질 및 특성에 관한 사항\n■ 조립·설치 순서 및 안전작업방법에 관한 사항\n■ 보호구 착용 및 작업 점검에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-29`,
        value: `29. 콘크리트 인공구조물(그 높이가 2미터 이상인 것만 해당한다)의 해체 또는 파괴작업`,
        textarea: `■ 콘크리트 해체기계의 점검에 관한 사항\n■ 파괴 시의 안전거리 및 대피 요령에 관한 사항\n■ 작업방법·순서 및 신호 방법 등에 관한 사항\n■ 해체·파괴 시의 작업안전기준 및 보호구에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-30`,
        value: `30. 타워크레인을 설치(상승작업을 포함한다)·해체하는 작업`,
        textarea: `■ 붕괴·추락 및 재해 방지에 관한 사항\n■ 설치·해체 순서 및 안전작업방법에 관한 사항\n■ 부재의 구조·재질 및 특성에 관한 사항\n■ 신호방법 및 요령에 관한 사항\n■ 이상 발생 시 응급조치에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-31`,
        value: `31. 보일러(소형 보일러 및 다음 각 목에서 정하는 보일러는 제외한다)의 설치 및 취급작업\n가. 몸통 반지름이 750밀리미터 이하이고 그 길이가 1,300밀리미터 이하인 증기보일러\n나. 전열면적이 3제곱미터 이하인 증기보일러\n다. 전열면적이 14제곱미터 이하인 온수보일러\n라. 전열면적이 30제곱미터 이하인 관류보일러(물관을 사용하여 가열시키는 방식의 보일러)`,
        textarea: `■ 기계 및 기기 점화장치 계측기의 점검에 관한 사항\n■ 열관리 및 방호장치에 관한 사항\n■ 작업순서 및 방법에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-32`,
        value: `32. 게이지 압력을 제곱센티미터당 1킬로그램 이상으로 사용하는 압력용기의 설치 및 취급작업`,
        textarea: `■ 안전시설 및 안전기준에 관한 사항\n■ 압력용기의 위험성에 관한 사항\n■ 용기 취급 및 설치기준에 관한 사항\n■ 작업안전 점검 방법 및 요령에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-33`,
        value: `33. 방사선 업무에 관계되는 작업(의료 및 실험용은 제외한다)`,
        textarea: `■ 방사선의 유해·위험 및 인체에 미치는 영향\n■ 방사선의 측정기기 기능의 점검에 관한 사항\n■ 방호거리·방호벽 및 방사선물질의 취급 요령에 관한 사항\n■ 응급처치 및 보호구 착용에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-34`,
        value: `34. 밀폐공간에서의 작업`,
        textarea: `■ 산소농도 측정 및 작업환경에 관한 사항\n■ 사고 시의 응급처치 및 비상 시 구출에 관한 사항\n■ 보호구 착용 및 보호 장비 사용에 관한 사항\n■ 작업내용ㆍ안전작업방법 및 절차에 관한 사항\n■ 장비ㆍ설비 및 시설 등의 안전점검에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-35`,
        value: `35. 허가 또는 관리 대상 유해물질의 제조 또는 취급작업`,
        textarea: `■ 취급물질의 성질 및 상태에 관한 사항\n■ 유해물질이 인체에 미치는 영향\n■ 국소배기장치 및 안전설비에 관한 사항\n■ 안전작업방법 및 보호구 사용에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-36`,
        value: `36. 로봇작업`,
        textarea: `■ 로봇의 기본원리·구조 및 작업방법에 관한 사항\n■ 이상 발생 시 응급조치에 관한 사항\n■ 안전시설 및 안전기준에 관한 사항\n■ 조작방법 및 작업순서에 관한 사항`,
      },
      {
        key: `special-37`,
        value: `37. 석면해체·제거작업`,
        textarea: `■ 석면의 특성과 위험성\n■ 석면해체·제거의 작업방법에 관한 사항\n■ 장비 및 보호구 사용에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-38`,
        value: `38. 가연물이 있는 장소에서 하는 화재위험작업`,
        textarea: `■ 작업준비 및 작업절차에 관한 사항\n■ 작업장 내 위험물, 가연물의 사용·보관·설치 현황에 관한 사항\n■ 화재위험작업에 따른 인근 인화성 액체에 대한 방호조치에 관한 사항\n■ 화재위험작업으로 인한 불꽃, 불티 등의 흩날림 방지 조치에 관한 사항\n■ 인화성 액체의 증기가 남아 있지 않도록 환기 등의 조치에 관한 사항\n■ 화재감시자의 직무 및 피난교육 등 비상조치에 관한 사항\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
      {
        key: `special-39`,
        value: `39. 타워크레인을 사용하는 작업시 신호업무를 하는 작업`,
        textarea: `■ 타워크레인의 기계적 특성 및 방호장치 등에 관한 사항\n■ 화물의 취급 및 안전작업방법에 관한 사항\n■ 신호방법 및 요령에 관한 사항\n■ 인양 물건의 위험성 및 낙하·비래·충돌재해 예방에 관한 사항\n■ 인양물이 적재될 지반의 조건, 인양하중, 풍압 등이 인양물과 타워크레인에 미치는 영향\n■ 그 밖에 안전·보건관리에 필요한 사항`,
      },
    ],
  },
  {
    key: `new-hire`,
    value: `채용시 안전교육`,
    child: [
      {
        key: `new-hire-direct`,
        value: `-`,
        textarea: `■ 산업안전 및 산업재해 예방에 관한 사항\n  (화재·폭발 사고 발생 시 대피에 관한 사항을 포함한다)\n\n■ 산업보건 및 건강장해 예방에 관한 사항\n\n■ 위험성평가에 관한 사항\n\n■ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항\n\n■ 직무스트레스 예방 및 관리에 관한 사항\n\n■ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항\n\n■ 기계·기구의 위험성과 작업의 순서 및 동선에 관한 사항\n\n■ 작업 개시 전 점검에 관한 사항\n\n■ 정리정돈 및 청소에 관한 사항\n\n■ 사고 발생 시 긴급조치에 관한 사항\n\n■ 물질안전보건자료에 관한 사항`,
      },
    ],
  },
  {
    key: `job-change`,
    value: `작업내용 변경시 안전교육`,
    child: [
      {
        key: `job-change-direct`,
        value: `-`,
        textarea: `■ 산업안전 및 산업재해 예방에 관한 사항\n  (화재·폭발 사고 발생 시 대피에 관한 사항을 포함한다)\n\n■ 산업보건 및 건강장해 예방에 관한 사항\n\n■ 위험성평가에 관한 사항\n\n■ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항\n\n■ 직무스트레스 예방 및 관리에 관한 사항\n\n■ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항\n\n■ 기계·기구의 위험성과 작업의 순서 및 동선에 관한 사항\n\n■ 작업 개시 전 점검에 관한 사항\n\n■ 정리정돈 및 청소에 관한 사항\n\n■ 사고 발생 시 긴급조치에 관한 사항\n\n■ 물질안전보건자료에 관한 사항`,
      },
    ],
  },
  {
    key: `chief-manager`,
    value: `안전보건총괄책임자 교육`,
    child: [{ value: `-`, textarea: `` }],
  },
  {
    key: `safety-manager`,
    value: `안전보건관리책임자 교육`,
    child: [
      { key: `safety-manager-direct`, value: `-`, textarea: `` },
      {
        key: `manager-chief`,
        value: `안전보건관리책임자`,
        textarea: `신규과정\n∎ 관리책임자의 책임과 직무에 관한 사항\n∎ 산업안전보건법령 및 안전·보건조치에 관한 사항\n\n보수과정\n∎ 산업안전·보건정책에 관한 사항\n∎ 자율안전·보건관리에 관한 사항`,
      },
      {
        key: `manager-safety`,
        value: `안전관리책임자 및 안전관리 전문기관 종사자`,
        textarea: `신규과정\n∎ 산업안전보건법령에 관한 사항\n∎ 산업안전보건개론에 관한 사항\n∎ 인간공학 및 산업심리에 관한 사항\n∎ 안전보건교육방법에 관한 사항\n∎ 재해 발생 시 응급처치에 관한 사항\n∎ 안전점검·평가 및 재해 분석기법에 관한 사항\n∎ 안전기준 및 개인보호구 등 분야별 재해예방 실무에 관한 사항\n∎ 산업안전보건관리비 계상 및 사용기준에 관한 사항\n∎ 작업환경 개선 등 산업위생 분야에 관한 사항\n∎ 무재해운동 추진기법 및 실무에 관한 사항\n∎ 위험성평가에 관한 사항\n∎ 그 밖에 안전관리자의 직무 향상을 위하여 필요한 사항\n\n보수과정\n∎ 산업안전보건법령 및 정책에 관한 사항\n∎ 안전관리계획 및 안전보건개선계획의 수립·평가·실무에 관한 사항\n∎ 안전보건교육 및 무재해운동 추진실무에 관한 사항\n∎ 산업안전보건관리비 사용기준 및 사용방법에 관한 사항\n∎ 분야별 재해 사례 및 개선 사례에 관한 연구와 실무에 관한 사항\n∎ 사업장 안전 개선기법에 관한 사항\n∎ 위험성평가에 관한 사항\n∎ 그 밖에 안전관리자 직무 향상을 위하여 필요한 사항`,
      },
      {
        key: `manager-health`,
        value: `보건관리자 및 보건관리 전문기관 종사자`,
        textarea: `신규과정\n∎ 산업안전보건법령 및 작업환경측정에 관한 사항\n∎ 산업안전보건개론에 관한 사항\n∎ 안전보건교육방법에 관한 사항\n∎ 산업보건관리계획 수립·평가 및 산업역학에 관한 사항\n∎ 작업환경 및 직업병 예방에 관한 사항\n∎ 작업환경 개선에 관한 사항(소음·분진·관리대상 유해물질 및 유해광선 등)\n∎ 산업역학 및 통계에 관한 사항\n∎ 산업환기에 관한 사항\n∎ 안전보건관리의 체제·규정 및 보건관리자 역할에 관한 사항\n∎ 보건관리계획 및 운용에 관한 사항\n∎ 근로자 건강관리 및 응급처치에 관한 사항\n∎ 위험성평가에 관한 사항\n∎ 감염병 예방에 관한 사항\n∎ 자살 예방에 관한 사항\n∎ 그 밖에 보건관리자의 직무 향상을 위하여 필요한 사항\n\n보수과정\n∎ 산업안전보건법령, 정책 및 작업환경 관리에 관한 사항\n∎ 산업보건관리계획 수립·평가 및 안전보건교육 추진 요령에 관한 사항\n∎ 근로자 건강 증진 및 구급환자 관리에 관한 사항\n∎ 산업위생 및 산업환기에 관한 사항\n∎ 직업병 사례 연구에 관한 사항\n∎ 유해물질별 작업환경 관리에 관한 사항\n∎ 위험성평가에 관한 사항\n∎ 감염병 예방에 관한 사항\n∎ 자살 예방에 관한 사항\n∎ 그 밖에 보건관리자 직무 향상을 위하여 필요한 사항`,
      },
      {
        key: `manager-staff`,
        value: `안전보건관리담당자`,
        textarea: `신규과정\n-\n\n보수과정\n∎ 위험성평가에 관한 사항\n∎ 안전·보건교육방법에 관한 사항\n∎ 사업장 순회점검 및 지도에 관한 사항\n∎ 기계·기구의 적격품 선정에 관한 사항\n∎ 산업재해 통계의 유지·관리 및 조사에 관한 사항\n∎ 그 밖에 안전보건관리담당자 직무 향상을 위하여 필요한 사항`,
      },
      {
        key: `manager-construction`,
        value: `건설재해예방 전문지도기관 종사자`,
        textarea: `신규과정\n∎ 산업안전보건법령 및 정책에 관한 사항\n∎ 분야별 재해사례 연구에 관한 사항\n∎ 새로운 공법 소개에 관한 사항\n∎ 사업장 안전관리기법에 관한 사항\n∎ 위험성평가의 실시에 관한 사항\n∎ 그 밖에 직무 향상을 위하여 필요한 사항\n\n보수과정\n∎ 산업안전보건법령 및 정책에 관한 사항\n∎ 분야별 재해사례 연구에 관한 사항\n∎ 새로운 공법 소개에 관한 사항\n∎ 사업장 안전관리기법에 관한 사항\n∎ 위험성평가의 실시에 관한 사항\n∎ 그 밖에 직무 향상을 위하여 필요한 사항`,
      },
      {
        key: `manager-asbestos`,
        value: `석면조사기관 종사자`,
        textarea: `신규과정
∎ 석면 제품의 종류 및 구별 방법에 관한 사항\n∎ 석면에 의한 건강유해성에 관한 사항\n∎ 석면 관련 법령 및 제도(법, 「석면안전관리법」 및 「건축법」등)에 관한 사항\n∎ 법 및 산업안전보건 정책방향에 관한 사항\n∎ 석면 시료채취 및 분석 방법에 관한 사항\n∎ 보호구 착용 방법에 관한 사항\n∎ 석면조사결과서 및 석면지도 작성 방법에 관한 사항\n∎ 석면 조사 실습에 관한 사항\n\n보수과정\n∎ 석면 관련 법령 및 제도(법, 「석면안전관리법」 및 「건축법」 등)에 관한 사항\n∎ 실내공기오염 관리(또는 작업환경측정 및 관리)에 관한 사항\n∎ 산업안전보건 정책방향에 관한 사항\n∎ 건축물·설비 구조의 이해에 관한 사항\n∎ 건축물·설비 내 석면함유 자재 사용 및 시공·제거 방법에 관한 사항\n∎ 보호구 선택 및 관리방법에 관한 사항\n∎ 석면해체·제거작업 및 석면 흩날림 방지 계획 수립 및 평가에 관한 사항\n∎ 건축물 석면조사 시 위해도평가 및 석면지도 작성·관리 실무에 관한 사항\n∎ 건축 자재의 종류별 석면조사실무에 관한 사항`,
      },
      {
        key: `manager-inspection`,
        value: `안전검사기관 및 자율안전 검사기관`,
        textarea: `신규과정\n∎ 산업안전보건법령에 관한 사항\n∎ 기계, 장비의 주요장치에 관한 사항\n∎ 측정기기 작동 방법에 관한 사항\n∎ 공통점검 사항 및 주요 위험요인별 점검내용에 관한 사항\n∎ 기계, 장비의 주요안전장치에 관한 사항\n∎ 검사시 안전보건 유의사항\n∎ 기계·전기·화공 등 공학적 기초 지식에 관한 사항\n∎ 검사원의 직무윤리에 관한 사항\n∎ 그 밖에 종사자의 직무 향상을 위하여 필요한 사항\n\n보수과정\n∎ 산업안전보건법령 및 정책에 관한 사항\n∎ 주요 위험요인별 점검내용에 관한 사항\n∎ 기계, 장비의 주요장치와 안전장치에 관한 심화과정\n∎ 검사시 안전보건 유의 사항\n∎ 구조해석, 용접, 피로, 파괴, 피해예측, 작업환기, 위험성평가 등에 관한 사항\n∎ 검사대상 기계별 재해 사례 및 개선 사례에 관한 연구와 실무에 관한 사항\n∎ 검사원의 직무윤리에 관한 사항\n∎ 그 밖에 종사자의 직무 향상을 위하여 필요한 사항`,
      },
    ],
  },
  {
    key: `supervisor`,
    value: `관리감독자 안전교육`,
    child: [
      {
        key: `supervisor-direct`,
        value: `-`,
        textarea: `■ 산업안전 및 산업재해 예방에 관한 사항\n  (화재·폭발 사고 발생 시 대피에 관한 사항을 포함한다)\n\n■ 산업보건 및 건강장해 예방에 관한 사항\n\n■ 위험성평가에 관한 사항\n\n■ 산업안전보건법령 및 산업재해보상보험 제도에 관한 사항\n\n■ 직무스트레스 예방 및 관리에 관한 사항\n\n■ 직장 내 괴롭힘, 고객의 폭언 등으로 인한 건강장해 예방 및 관리에 관한 사항\n\n■ 기계·기구의 위험성과 작업의 순서 및 동선에 관한 사항\n\n■ 작업 개시 전 점검에 관한 사항\n\n■ 정리정돈 및 청소에 관한 사항\n\n■ 사고 발생 시 긴급조치에 관한 사항\n\n■ 물질안전보건자료에 관한 사항`,
      },
    ],
  },
  {
    key: `msds`,
    value: `MSDS`,
    child: [
      {
        key: `msds-direct`,
        value: `-`,
        textarea: `■ 대상화학물질의 명칭 또는 제품명\n\n■ 물리적 위험성 및 건강 유해성\n\n■ 취급상의 주의사항\n\n■ 적절한 보호구\n\n■ 응급조치 요령 및 사고 시 대처방법\n\n■ 물질안전보건자료 및 경고표지를 이해하는 방법`,
      },
    ],
  },
  {
    key: `etc`,
    value: `기타`,
    child: [{ value: `-`, textarea: `` }],
  },
];
